"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Module = void 0;
var Module = exports.Module = {
  dashboard: 'dashboard',
  meineausbildung: 'meineausbildung',
  nachweise: 'nachweise',
  ausbildungsplan: 'ausbildungsplan',
  versetzungsplan: 'versetzungsplan',
  praxisaufgabenOverview: 'praxisaufgabenOverview',
  wissensportal: 'wissensportal',
  feedback: 'feedback',
  chat: 'chat'
};